import styled, { css } from "styled-components";

const StyledCredit = styled.cite`
  font-family: var(--font-sans);
  font-style: normal;
  font-size: 0.6875em;
  color: var(--theme-text-against-dark-medium);
  display: block;
  text-align: left;
  margin-top: 0.625em;
  line-height: 1.3;
`;

export default StyledCredit;